import { Link } from "react-router-dom";

export default function NotFound({ title = "Page not found" }) {
    return <main className="mx-auto max-w-3xl p-8">
        <h1>{title}</h1>
        <p>This link may be out of date.</p>
        <Link to="/">Back to the party calendar</Link>
    </main>;
}
